// extracted by mini-css-extract-plugin
export default {"custom-header":"EntityInformation_custom-header__dGfAK","container":"EntityInformation_container__XU3Fu","image":"EntityInformation_image__XcxIG"};